import { useState } from "react";
import { trustPoints, faqItems } from "@/mocks/gua";

export default function TrustFaq() {
  const [open, setOpen] = useState<string | null>(faqItems[0].id);

  return (
    <section id="faq" className="mx-auto max-w-6xl scroll-mt-24 px-4 pt-12 md:px-6 md:pt-16">
      {/* 信任区 */}
      <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-9">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-shield-check-line" /> 关于本站 · 内容原则
          </span>
          <h3 className="mt-4 text-2xl font-black text-foreground-950">吃瓜要热闹，也要有底线</h3>
          <p className="mt-2 text-sm leading-6 text-foreground-700 md:text-[15px] md:leading-7">
            色瓜网做的是“整理”而不是“定罪”。每一条劲爆猛料，我们都尽量给出来源、状态与进展，而不是只丢一个抓人眼球的标题。
          </p>
        </div>
        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {trustPoints.map((p) => (
            <div key={p.id} className="flex flex-col rounded-lg bg-background-100 p-4">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className={`${p.icon} text-lg`} />
              </span>
              <p className="mt-3 text-sm font-bold text-foreground-900">{p.title}</p>
              <p className="mt-1 text-xs leading-5 text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-5 md:mt-16">
        <div className="lg:col-span-2">
          <h3 className="flex items-center gap-2 text-xl font-bold text-foreground-950">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-question-line" />
            </span>
            常见疑问
          </h3>
          <p className="mt-2 text-sm leading-6 text-foreground-600">
            关于来源可信度、内容尺度与进展更新的高频问题。看懂这几条，再看爆料会更从容。
          </p>
          <a href="#" className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800">
            有话说？找编辑反馈 <i className="ri-arrow-right-up-line" />
          </a>
        </div>
        <div className="space-y-3 lg:col-span-3">
          {faqItems.map((f) => {
            const isOpen = open === f.id;
            return (
              <div key={f.id} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : f.id)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-[15px]">{f.q}</span>
                  <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform ${isOpen ? "rotate-45" : ""}`}>
                    <i className="ri-add-line" />
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-6 text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}